var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendingMail = function SvgSendingMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 94,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93.053,
    height: 93.053,
    x: 7.307,
    fill: "url(#sending-mail_svg__a)",
    rx: 22.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sending-mail_svg__b)",
    fillRule: "evenodd",
    d: "M.592 33.605a23.18 23.18 0 0 0 2.529 16.83l4.1 7.104c9.402.459 18.674-.151 27.47-1.174 9.496-1.104 22.058-1.897 37.174-1.357l.83-23.248c-16.386-.586-30.127.27-40.691 1.497-10.931 1.271-21.478 1.686-31.412.348",
    clipRule: "evenodd",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4BACA",
    d: "M66.81 31.742a2.423 2.423 0 0 1 2.423-2.424h31.128V61.59H69.233a2.423 2.423 0 0 1-2.423-2.423z",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEEF7",
    d: "M63.723 29.287a2.326 2.326 0 0 1 2.326-2.326h41.874a2.326 2.326 0 0 1 2.326 2.326v27.916a2.326 2.326 0 0 1-2.326 2.326H66.049a2.326 2.326 0 0 1-2.326-2.326z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sending-mail_svg__c)",
    d: "M63.723 29.287a2.326 2.326 0 0 1 2.326-2.326h41.874a2.326 2.326 0 0 1 2.326 2.326v27.916a2.326 2.326 0 0 1-2.326 2.326H66.049a2.326 2.326 0 0 1-2.326-2.326z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE3FF",
    d: "M63.723 29.287a2.326 2.326 0 0 1 2.326-2.326h41.874a2.326 2.326 0 0 1 2.326 2.326v27.916a2.326 2.326 0 0 1-2.326 2.326H66.049a2.326 2.326 0 0 1-2.326-2.326z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3391FF",
    fillRule: "evenodd",
    d: "M63.723 32.288v-2.223l23.919 15.221 22.607-15.209v2.26l-22.07 14.847-.509.343-.517-.33z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3391FF",
    d: "m69.539 59.53 9.013-18.611 7.793 5.1c.779.51 1.786.506 2.56-.009l7.668-5.091 9.024 18.61z",
    opacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sending-mail_svg__d)",
    stroke: "#3391FF",
    strokeLinecap: "round",
    strokeWidth: 1.875,
    d: "M87.188 49.688a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.124Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1214",
    strokeLinecap: "round",
    strokeWidth: 0.969,
    d: "m89.249 41.416-3.358 3.358a.097.097 0 0 1-.138 0l-1.33-1.331"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2EFFD",
    d: "M117.265 19.96a.417.417 0 0 1 .782 0l.894 2.415a.42.42 0 0 0 .246.247l2.416.893a.417.417 0 0 1 0 .782l-2.416.894a.42.42 0 0 0-.246.246l-.894 2.416a.417.417 0 0 1-.782 0l-.894-2.416a.42.42 0 0 0-.246-.246l-2.415-.894a.417.417 0 0 1-.001-.782l2.416-.893a.42.42 0 0 0 .246-.247z",
    opacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#74FFFF",
    d: "M27.33 55.685a.57.57 0 0 1 1.07 0l.606 1.639a.57.57 0 0 0 .337.337l1.639.606a.57.57 0 0 1 0 1.07l-1.64.606a.57.57 0 0 0-.336.337l-.607 1.64a.57.57 0 0 1-1.07 0l-.606-1.64a.57.57 0 0 0-.337-.337l-1.639-.606a.57.57 0 0 1 0-1.07l1.64-.606a.57.57 0 0 0 .336-.337z",
    opacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.877,
    height: 3.877,
    x: 59.705,
    y: 51.349,
    fill: "#74FFFF",
    opacity: 0.8,
    rx: 0.485,
    transform: "rotate(-45 59.705 51.349)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 1.939,
    x: 29.657,
    y: 46.502,
    fill: "#7A69FD",
    opacity: 0.4,
    rx: 0.485,
    transform: "rotate(-45 29.657 46.502)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 1.939,
    x: 46.875,
    y: 63.246,
    fill: "#74FFFF",
    opacity: 0.8,
    rx: 0.485,
    transform: "rotate(-45 46.875 63.246)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 1.939,
    x: 44.196,
    y: 31.72,
    fill: "#74FFFF",
    opacity: 0.8,
    rx: 0.485,
    transform: "rotate(-45 44.196 31.72)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sending-mail_svg__a",
    x1: 71.25,
    x2: 15.469,
    y1: 70.313,
    y2: 4.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sending-mail_svg__b",
    x1: -14.548,
    x2: 139.154,
    y1: 58.379,
    y2: 85.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEDFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sending-mail_svg__c",
    x1: 85.854,
    x2: 154.082,
    y1: 27.773,
    y2: 162.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#B4BACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sending-mail_svg__d",
    x1: 82.031,
    x2: 95.599,
    y1: 39.062,
    y2: 45.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })))));
};
export default SvgSendingMail;